import store from '../store/index'
import router from './index.js'
import {queryPlatformInfoById} from '../api/index.js'
import getParams from '../utils/getParams.js'
import setTheme from '../theme/setTheme.js'
import {Toast} from 'vant'

router.beforeEach((to, from, next) => {
  if (store.state.platformInfo) {
    next()
  } else {
    let {platformType, fromUserType, platformTerminalType} = getParams()
    queryPlatformInfoById({
      id: platformType,
      platformUserType: fromUserType,
      terminalType: platformTerminalType
    }).then(res => {
      if (res.resultCode === 0 && res.resultData) {
        setTheme(res.resultData)
        store.commit('setPlatformInfo', res.resultData)
        next()
      } else {
        Toast('平台有误')
      }
    }).catch(() => {
      Toast('平台有误')
    })
  }
})



// WEBPACK FOOTER //
// ./src/router/routerControl.js